export interface EMSNSearchForm {
  claimNumber: string
}

export const defaultEMSNSearchForm = {
  claimNumber: ''
}
